import BaseApi from "./BaseApi";

class VisitorApi extends BaseApi{

    async getVisitorById(id){
        try{
            const endpoint = `api/Visitors/${id}`;
            const response = await this.get(endpoint);
            return response.data;
        }
        catch(error){
            console.error("Error in getVisitorByGuid:", error);
            throw new Error("unable to retrieve user info");
        }
    }

    async getVisitorByGuid(guid){
        try{
            const endpoint = `api/Visitors/byGuid/${guid}`;
            const response = await this.get(endpoint);
            return response.data;
        }
        catch(error){
            console.error("Error in getVisitorByGuid:", error);
            throw new Error("unable to retrieve user info");
        }
    }

    async getVisitorsByHome(homeId){
        try{
            const endpoint = `api/Visitors/All/${homeId}`;
            const response = await this.get(endpoint);
            return response.data;
        }
        catch(error){
            console.error("Error in getVisitorsByHome:", error);
            throw new Error("unable to retrieve user info");
        }
    }

    async createVisitor(visitor){
        try{
            const endpoint = `api/Visitors`;
            const response = await this.post(endpoint, visitor);
            return response;
        }
        catch(error){
            if(error.response){
                throw new Error(error.response.data);
            }                
            else{
                throw new Error(error.message);
            } 
        }
    }

    async deleteVisitor(id){
        try{
            const endpoint = `api/Visitors/${id}`;
            const response = await this.post(endpoint);
            return response;
        }
        catch(error){
            if(error.response){
                throw new Error(error.response.data);
            }                
            else{
                throw new Error(error.message);
            }              
        }
    }
}

export default new VisitorApi();